<template>
    <div
      class="mt-8">
      <v-layout wrap>
        <v-flex>
          <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="green">
            <span 
              class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>
  
            <template v-slot:action="{ attrs }">
              <v-btn
                icon
                color="white"
                class="body-1 font-weight-bold text-capitalize"
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
  
          <v-dialog v-model="dialog.freeze"
            @keydown.esc="dialog.freeze = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pt-3 pb-0 text-right popup-header">
                Freeze Kolom
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-3 mb-2"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-text 
                class="py-0">
                <v-form>
                  <v-row>
                    <v-col>
                      <div>
                        <div 
                          class="mb-2">
                          Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                        </div>
  
                        <v-list-item-group
                          multiple>
                          <v-list flat>
                            <v-list-item 
                              v-for="(item, index) in configHeaders" 
                              :key="index"
                              class="px-0"
                              @click="item.freeze = !item.freeze ? true : false">
                              <v-list-item-action 
                                class="mr-4">
                                <v-checkbox
                                  color="#718EBF"
                                  :input-value="item.freeze">
                                </v-checkbox>
                              </v-list-item-action>
  
                              <v-list-item-content>
                                <div
                                  :class="item.freeze ? 'font-weight-bold' : ''"
                                  :style="item.freeze ? `color: ${set_color};` : ''">
                                  {{ item.text }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>  
                          </v-list>
                        </v-list-item-group>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
  
              <v-divider 
                class="mb-3 mt-0"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-actions
                class="mb-2">
                <v-spacer/>
  
                <v-btn
                  elevation="0"
                  color="#718EBF"
                  style="border-radius: 10px;"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                  <v-icon small class="mr-1">mdi-check-bold</v-icon>
                  Freeze
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.hide"
            @keydown.esc="dialog.hide = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pt-3 pb-0 text-right popup-header">
                Hide Kolom
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.hide = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-3 mb-2"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-text 
                class="py-0">
                <v-form>
                  <v-row>
                    <v-col>
                      <div>
                        <div class="mb-2">
                          Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                        </div>
  
                        <v-list-item-group
                          multiple>
                          <v-list flat>
                            <v-list-item 
                              v-for="(item, index) in headers" 
                              :key="index"
                              class="px-0"
                              @click="item.hide = !item.hide ? true : false">
                              <v-list-item-action 
                                class="mr-4">
                                <v-checkbox
                                  color="#718EBF"
                                  :input-value="item.hide">
                                </v-checkbox>
                              </v-list-item-action>
  
                              <v-list-item-content>
                                <div
                                  :class="item.hide ? 'font-weight-bold' : ''"
                                  :style="item.hide ? `color: ${set_color};` : ''">
                                  {{ item.text }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>  
                          </v-list>
                        </v-list-item-group>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
  
              <v-divider 
                class="mb-3 mt-0"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-actions
                class="mb-2">
                <v-spacer/>
  
                <v-btn
                  elevation="0"
                  color="#718EBF"
                  style="border-radius: 10px;"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                  <v-icon small class="mr-1">mdi-check-bold</v-icon>
                  Hide
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.filter"
            @keydown.esc="dialog.filter = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                <div
                  class="title font-weight-bold">
                  Filter Data
                </div>
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.filter = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-text 
                class="py-0 my-4">
                <v-select
                  filled
                  rounded
                  dense
  
                  color="#718EBF"
                  placeholder="Contoh. 2023"
  
                  hide-details
  
                  :items="years"
                  :item-color="set_color"
  
                  v-model="filter.year"
                  style="border-radius: 10px;">
                </v-select>
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-actions
                class="pa-4">
                <v-spacer/>
  
                <v-btn 
                  @click="dialog.filter = false; fetch();"
                  width="120"
                  elevation="0"
                  color="green"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Filter
                </v-btn>
  
                <v-btn 
                  @click="dialog.filter = false"
                  width="120"
                  outlined
                  elevation="0"
                  color="red"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.form"
            @keydown.esc="dialog.form = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header">
                <div
                  class="fs-20 font-weight-bold">
                  Mengubah Status Customer
                </div>
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.form = false; reset();"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="py-3 my-2 px-0">
                
                
  
                <div v-if="message.error.length > 0"
                  class="text-center mt-6">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
              
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0">
                <v-spacer/>
  
                <v-btn 
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="150"
                  height="45"
                  elevation="0"
                  color="#2374e9"
                  class="fs-16 white--text text-capitalize border-radius">
                  Simpan
                </v-btn>
  
                <v-btn
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="120"
                  height="45"
                  elevation="0"
                  color="warning"
                  class="fs-16 white--text text-capitalize border-radius">
                  Ditolak
                </v-btn>
  
                <!-- <v-btn 
                  @click="dialog.form = false; reset();"
                  :disabled="process.form"
                  width="120"
                  outlined
                  elevation="0"
                  color="red"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
  
  
          <v-dialog v-model="dialog.delete"
            @keydown.esc="dialog.delete = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Hapus Data
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
  
                <div v-if="message.error.length > 0"
                  class="text-center mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
  
  
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  @click="deletes()"
                  :loading="process.delete"
                  :disabled="process.delete"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#2374e9"
                  class="fs-16 white--text text-capitalize border-radius">
                  Ya, Hapus
                </v-btn>
  
                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  :disabled="process.delete"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <section>
  
            <!-- <div class="d-flex mb-3">
              <div>
                <div class="fs-22 color-dark-blue font-weight-medium">
                  Data Invoice Customer
                </div>
              </div>
              <v-spacer />
              <div>
                <v-btn
                  color="#2374e9"
                  width="195"
                  height="50"
                  elevation="0"
                  style="border-radius: 9px;"
                  to="/finance/invoice/add"
                  class="fs-16 white--text text-capitalize">
                  <v-icon size="18" class="mr-1 pt-1">mdi-plus</v-icon>
                  Tambah Invoice
                </v-btn>
              </div>
            </div> -->

          <v-card 
            flat
            class="ma-4 mt-0 box-shadow pb-5"
            style="border-radius: 10px;">

            <v-row
              class="pa-4 py-0">
              <v-col
                cols="12"
                md="7">
                <span
                  class="fs-16 black--text ml-2"
                  style="font-weight: 600;">
                  Data Pengajuan Invoice
                </span>
                <!-- <div
                  class="body-2">
                  Perbandingan SP2D 

                  <span v-if="filter.year !== '' && filter.year !== null">
                    tahun <strong class="black--text">{{ filter.year }}</strong>
                  </span>

                  <span v-if="filter.month !== '' && filter.month !== null">
                    di bulan <strong class="black--text">{{ filter.month_text }}</strong>
                  </span>
                </div> -->
              </v-col>
              <v-col
                cols="12"
                md="12"
                class="d-flex align-center">
                <v-btn
                  elevation="0"
                  :disabled="process.load"
                  @click="openDialogPilihInvoice()"
                  class="body-2 white--text text-capitalize d-flex align-center ml-0"
                  style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1))">
                  <v-icon size="18" class="mr-1">mdi-plus-circle</v-icon>
                  <span>Tambah Pembayaran</span>
                </v-btn>
                <v-text-field
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"

                  filled
                  rounded
                  dense
                  single-line

                  hide-details
                  :color="set_color"
                  placeholder="Cari data yang Anda butuhkan . . ."
                  append-icon="mdi-magnify"
                  clearable

                  v-model="search"
                  class="ml-3 fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
                </v-text-field>

                <!-- FREEZE COLUMN -->
                <!-- <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.freeze = true">
                        <v-icon size="18">mdi-table-split-cell</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Freeze
                    </span>
                  </v-tooltip>
                </div> -->

                <!-- HIDE COLUMN -->
                <!-- <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.hide = true">
                        <v-icon size="18">mdi-eye-off-outline</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Hide
                    </span>
                  </v-tooltip>
                </div> -->
              </v-col>
            </v-row>

            <v-card 
              flat
              class="mt-0 mx-5"
              style="border-radius: 6px; border: 1px solid #E7E7E7;">
              <!-- :height="`calc(100vh - ${pagination.total_data > 0 ? '320px' : '148px'})`" -->
              <div class="view">
                <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper-pengajuan-invoice'">
                  <table style="border-radius: 10px; width: 100%;" class="table">
                    <tr>
                      <th class="sticky-col-pengajuan-invoice one-col-pengajuan-invoice" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 120px; min-width: 120px; max-width: 120px; padding: 8px 12px; text-align: center;">Aksi</th>
                      <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">No. Invoice</th>
                      <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">Metode Pembayaran</th>
                      <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; width: 1px; white-space: nowrap; text-align: right;">Total Dibayar</th>
                      <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; min-width: 100px;; text-align: right;">Sisa Tagihan</th>
                      <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 100px;; text-align: left;">Nama Penerima</th>
                      <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 100px;; text-align: left;">Status</th>
                      <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 100px;; text-align: left;">Tanggal Diterima</th>
                      <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 100px;; text-align: left;">Tanggal Input</th>
                      <!-- <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;"></th> -->
                      <!-- <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">Realisasi</th>
                      <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Selisih</th> -->
                    </tr>
                    <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                      <td class="sticky-col-pengajuan-invoice one-col-pengajuan-invoice" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 80px; min-width: 80px; max-width: 80px; padding: 8px 12px; text-align: center;">
                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                            :to="`/kasir/customer/detail/${item.invoice_id}`"
                              
                              v-bind="attrs"
                              v-on="on"
                              
                              min-width="28"
                              small
                              rounded
                              color="green"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-information-outline</v-icon>
                            </v-btn>
                          </template>
    
                          <span>Detail</span>
                        </v-tooltip>

                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="openDialogUpdatePembayaran(item)"
                              v-bind="attrs"
                              v-on="on"
                              min-width="28"
                              small
                              rounded
                              color="blue"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-square-edit-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit Pembayaran</span>
                        </v-tooltip>
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.invoice_number }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;" class="text-capitalize">{{ item.payment_method }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 1px; white-space: nowrap; text-align: left; text-align: right;">
                        {{ item.total_paid*1 | price }}
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; min-width: 200px;; text-align: right;">{{ item.sisa_tagihan*1 | price }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 200px;; text-align: left;">{{ item.receipt_user_name }} ({{ item.receipt_user_category | capitalize }})</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 100px;; text-align: left;">{{ item.sudah_diterima === 'sudah' ? 'Sudah' : 'Belum' }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 220px;; text-align: left;">{{ item.diterima_date | dateFull }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 300px;; text-align: left;">{{ item.input_datetime | dateFullTime }}</td>
                      
                      <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">{{ (item.realisasi*1) | price }}</td> -->
                      <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">
                        {{ ((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' :((item.nominal*1) + (item.nominal_sp2b*1)) > (item.realisasi*1) ? '-' : '+'}}
                        {{ (((item.nominal*1) + (item.nominal_sp2b*1)) - (item.realisasi*1)) | price }}
                      </td> -->
                    </tr>
                  </table>
                </div>

                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" 
                  style="height: calc(100vh - 315px); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-4 title">
                      Mohon Tunggu . . .
                    </div>

                    <v-progress-linear
                      :color="set_color"
                      indeterminate
                      rounded
                      height="10">
                    </v-progress-linear>
                  </div>
                </v-card-text>

                <v-card-text
                  v-if="list.length === 0 && !process.load"
                  class="pb-0 my-4" style="height: calc( 100vh - 315px ); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <v-img 
                      class="mx-auto"
                      contain
                      alt="vuetify"
                      :width="90"
                      :height="90"
                      :src="require('@/assets/image/empty.png')">
                      <!-- <template v-slot:placeholder>
                        <v-row
                          class=" "
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template> -->
                    </v-img>
                    <div class="mt-3 fs-16">
                      Belum Ada Data
                    </div>
                  </div>
                </v-card-text>

                <pagination v-if="!process.load && pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination" :display="paginationList"/>

              </div>


              <!-- <pagination v-if="pagination.total_data > 0"
                @changePage="fetch($event)" 
                @reloadPage="fetch($event)" 
                :model="pagination"/> -->
            </v-card>
          </v-card>
  
          </section>
        </v-flex>
      </v-layout>

      <!-- Dialog Pilih Invoice -->
      <v-dialog v-model="dialog.pilihInvoice"
        @keydown.esc="dialog.pilihInvoice = false"
        max-width="900"
        persistent
        scrollable>
        <v-card 
          style="border-radius: 16px; overflow: hidden;">
          <v-card-title 
            class="pa-4"
            style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
            <div class="d-flex align-center">
              <v-avatar size="36" color="white" class="mr-3">
                <v-icon color="#2374e9" size="18">mdi-file-document-outline</v-icon>
              </v-avatar>
              <div>
                <div class="fs-16 white--text font-weight-bold" style="line-height: 1.5;">Pilih Invoice</div>
                <div class="fs-11 white--text" style="opacity: 0.9; line-height: 1.5;">
                  Pilih invoice yang akan ditambahkan pembayaran
                </div>
              </div>
            </div>
            <v-spacer/>
            <v-btn
              @click="closeDialogPilihInvoice()"
              icon
              small
              class="white--text">
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-0">
            <div class="px-4 pt-3 pb-3">
              <div class="d-flex align-center mb-3" style="gap: 12px;">
                <v-text-field
                  v-model="searchInvoice"
                  @keyup.enter="fetchInvoiceList(true)"
                  @click:clear="searchInvoice = ''; fetchInvoiceList(true);"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details
                  placeholder="Cari invoice..."
                  append-icon="mdi-magnify"
                  clearable
                  style="border-radius: 6px; flex: 1; width: 250px;">
                </v-text-field>

                <v-autocomplete
                  v-model="filterDataTokoInvoice"
                  :items="toko"
                  :search-input.sync="searchToko"
                  item-text="name"
                  item-value="name"
                  clearable
                  @click:clear="filterDataTokoInvoice = ''; searchToko = ''; fetchInvoiceList(true);"
                  hide-details
                  @change="fetchInvoiceList(true)"
                  @update:search-input="onSearchToko"
                  :loading="processToko.load"
                  filled
                  rounded
                  dense
                  class="fs-12"
                  color="#718EBF"
                  placeholder="Nama Toko"
                  :item-color="set_color"
                  style="border-radius: 6px; width: 150px;">
                </v-autocomplete>
              </div>

              <div v-if="processInvoice.load && invoicePagination.page === 1" class="text-center py-8">
                <v-progress-circular
                  indeterminate
                  :color="set_color"
                  size="48">
                </v-progress-circular>
                <div class="mt-3">Memuat data invoice...</div>
              </div>

              <div v-else-if="listInvoice.length === 0 && !processInvoice.loadMore" class="text-center py-8">
                <v-icon size="64" color="grey">mdi-file-document-outline</v-icon>
                <div class="mt-3 grey--text">Tidak ada invoice yang tersedia</div>
              </div>

              <div style="max-height: 400px; overflow-y: auto; min-height: 400px;" v-else>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in listInvoice"
                    :key="index"
                    @click="selectInvoice(item)"
                    class="mb-2"
                    style="border: 1px solid #E5E7EB; border-radius: 8px; cursor: pointer;"
                    :class="selectedInvoiceItem && selectedInvoiceItem.id === item.id ? 'selected-invoice' : ''">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold mb-1">
                        {{ item.number || item.invoice_number }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <div class="d-flex align-center mt-1">
                          <span class="mr-4">
                            <v-icon size="16" class="mr-1">mdi-account</v-icon>
                            {{ item.customer_name || '-' }}
                          </span>
                          <span class="mr-4">
                            <v-icon size="16" class="mr-1">mdi-store</v-icon>
                            {{ item.store_name || '-' }}
                          </span>
                          <span class="mr-4">
                            <v-icon size="16" class="mr-1">mdi-cash</v-icon>
                            {{ (((item.orders_detail.reduce((sum, k) => sum + ((Math.round((k.price_per_pcs*1) * (k.total_in_dus*1)) * (k.qty_dus_diterima*1))), 0))) - item.orders_detail.reduce((sum, i) => sum + (i.discount*1), 0) - item.orders_detail.reduce((sum, i) => sum + ((i.strata_nominal*1) * (i.qty_dus_diterima*1)), 0)) | price }}
                          </span>
                          <span>
                            <v-icon size="16" class="mr-1">mdi-calendar</v-icon>
                            {{ item.due_date | date }}
                          </span>
                        </div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon color="#2374e9">mdi-chevron-right</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
  
                <div v-if="listInvoice.length > 0 && hasMoreInvoice" class="text-center mt-2 mb-1">
                  <v-btn
                    @click="loadMoreInvoice()"
                    :loading="processInvoice.loadMore"
                    outlined
                    small
                    class="text-capitalize"
                    color="#2374e9"
                    style="border-radius: 8px;">
                    <v-icon left size="16">mdi-chevron-down</v-icon>
                    Tampilkan Lebih Banyak
                  </v-btn>
                </div>
              </div>

            </div>
          </v-card-text>

          <v-card-actions class="pa-3">
            <v-spacer/>
            <v-btn
              @click="closeDialogPilihInvoice()"
              outlined
              small
              height="38"
              style="border-radius: 8px; min-width: 110px;"
              class="mr-2 text-capitalize">
              <v-icon left size="16">mdi-close</v-icon>
              Batal
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog Tambah Pembayaran -->
      <v-dialog v-model="dialog.tambahPembayaran"
        @keydown.esc="dialog.tambahPembayaran = false"
        max-width="760"
        persistent
        scrollable>
        <v-card 
          style="border-radius: 16px; overflow: hidden;"
          class="payment-form-dialog">
          <v-card-title 
            class="payment-form-header pa-4"
            style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
            <div class="d-flex align-center">
              <v-avatar size="36" color="white" class="mr-3">
                <v-icon color="#2374e9" size="18">mdi-cash-plus</v-icon>
              </v-avatar>
              <div>
                <div class="fs-16 white--text font-weight-bold" style="line-height: 1.5;">Tambah Pembayaran</div>
                <div class="fs-11 white--text" style="opacity: 0.9; line-height: 1.5;">
                  Lengkapi informasi pembayaran untuk invoice ini
                </div>
              </div>
            </div>
            <v-spacer/>
            <v-btn
              @click="closeDialogTambahPembayaran()"
              icon
              small
              class="white--text">
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-0">
            <div class="px-4 pt-3 pb-3">
              <ValidationObserver ref="formTambahPembayaran">
                <v-form>
                  <!-- Section 1: Informasi Pembayaran -->
                  <div class="form-section mb-4">
                    <div class="section-header mb-3">
                      <v-icon color="#2374e9" size="18" class="mr-2">mdi-information-outline</v-icon>
                      <span class="fs-15 font-weight-bold black--text">Informasi Pembayaran</span>
                    </div>
                    
                    <!-- Informasi Invoice -->
                    <v-card 
                      flat
                      style="border-radius: 8px; background: #fff; border: 1px solid #E5E7EB;"
                      class="mb-4">
                      <v-card-text class="pa-3 py-0">
                        <v-row>
                          <v-col cols="12" md="6" class="pb-2">
                            <div class="d-flex align-center mb-2">
                              <v-icon color="#2374e9" size="18" class="mr-2">mdi-file-document-outline</v-icon>
                              <div>
                                <div class="text-caption grey--text">No. Invoice</div>
                                <div class="text-body-2 font-weight-bold black--text">{{ selectedInvoice ? (selectedInvoice.number || selectedInvoice.invoice_number || '-') : '-' }}</div>
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6" class="pb-2">
                            <div class="d-flex align-center mb-2">
                              <v-icon color="#2374e9" size="18" class="mr-2">mdi-store</v-icon>
                              <div>
                                <div class="text-caption grey--text">Nama Toko</div>
                                <div class="text-body-2 font-weight-bold black--text">{{ selectedInvoice ? (selectedInvoice.store_name || '-') : '-' }}</div>
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6" class="pb-2">
                            <div class="d-flex align-center mb-2">
                              <v-icon color="#2374e9" size="18" class="mr-2">mdi-account</v-icon>
                              <div>
                                <div class="text-caption grey--text">Nama Customer</div>
                                <div class="text-body-2 font-weight-bold black--text">{{ selectedInvoice ? (selectedInvoice.customer_name || '-') : '-' }}</div>
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6" class="pb-2">
                            <div class="d-flex align-center mb-2">
                              <v-icon color="#2374e9" size="18" class="mr-2">mdi-receipt</v-icon>
                              <div>
                                <div class="text-caption grey--text">No. Order</div>
                                <div class="text-body-2 font-weight-bold black--text">{{ selectedInvoice ? (selectedInvoice.orders_number || '-') : '-' }} {{ selectedInvoice?.total_paid*1 }}</div>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                    
                    <v-row>
                      <v-col cols="12" md="6" class="pb-0">
                        <ValidationProvider
                          name="Total Dibayar" 
                          :rules="`required|min_value:0|max_value:${(getInvoiceNetTotal(selectedInvoice) - ((selectedInvoice?.total_paid*1) || 0))}`"
                          v-slot="{ errors }">
                          <div class="fs-14 label-input font-weight-medium mb-2">
                            <v-icon size="16" color="#718EBF" class="mr-1">mdi-cash</v-icon>
                            Total Dibayar
                          </div>
                          <v-currency-field
                            v-model="formPembayaran.total_paid"
                            @input="recalculateSisaTagihan"
                            filled
                            rounded
                            dense
                            solo
                            outlined
                            placeholder="Masukkan total pembayaran"
                            class="modern-input"
                            :error-messages="errors"
                            required
                            prefix="Rp"
                            style="border-radius: 10px;">
                          </v-currency-field>
                        </ValidationProvider>
                      </v-col>

                      <v-col cols="12" md="6" class="pb-0">
                        <div class="fs-14 label-input font-weight-medium mb-2">
                          <v-icon size="16" color="#718EBF" class="mr-1">mdi-alert-circle</v-icon>
                          Sisa Tagihan
                        </div>
                        <v-text-field
                          :value="formatCurrency(formPembayaran.sisa_tagihan)"
                          readonly
                          filled
                          rounded
                          dense
                          solo
                          outlined
                          class="modern-input"
                          style="border-radius: 10px;"
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" md="12" class="pb-0">
                        <ValidationProvider
                          name="Metode Pembayaran" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="fs-14 label-input font-weight-medium mb-2">
                            <v-icon size="16" color="#718EBF" class="mr-1">mdi-credit-card</v-icon>
                            Metode Pembayaran
                          </div>
                          <v-autocomplete
                            v-model="formPembayaran.payment_method"
                            :items="[
                              { text: 'Transfer', value: 'transfer', icon: 'mdi-bank-transfer' },
                              { text: 'Tunai', value: 'tunai', icon: 'mdi-cash' },
                              { text: 'Giro', value: 'giro', icon: 'mdi-file-document-outline' }
                            ]"
                            item-text="text"
                            item-value="value"
                            filled
                            rounded
                            dense
                            solo
                            outlined
                            placeholder="Pilih metode pembayaran"
                            class="modern-input"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;">
                            <template v-slot:item="{ item }">
                              <v-list-item-content>
                                <v-list-item-title>
                                  <v-icon size="18" class="mr-2" :color="getPaymentMethodColor(item.value)">
                                    {{ item.icon }}
                                  </v-icon>
                                  {{ item.text }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                            <template v-slot:selection="{ item }">
                              <div class="d-flex align-center">
                                <v-icon size="18" class="mr-2" :color="getPaymentMethodColor(item.value)">
                                  {{ item.icon }}
                                </v-icon>
                                {{ item.text }}
                              </div>
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- Section 2: Informasi Bank (jika transfer) -->
                  <div v-if="formPembayaran.payment_method === 'transfer'" class="form-section mb-4">
                    <div class="section-header mb-3">
                      <v-icon color="#2374e9" size="18" class="mr-2">mdi-bank</v-icon>
                      <span class="fs-15 font-weight-bold black--text">Informasi Bank</span>
                    </div>
                    
                    <v-row>
                      <v-col cols="12" md="6" class="pb-0">
                        <ValidationProvider
                          name="Nama Bank" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="fs-14 label-input font-weight-medium mb-2">
                            <v-icon size="16" color="#718EBF" class="mr-1">mdi-bank</v-icon>
                            Nama Bank
                          </div>
                          <v-autocomplete
                            v-model="formPembayaran.bank_name"
                            :items="bank"
                            item-text="name"
                            item-value="name"
                            filled
                            rounded
                            dense
                            solo
                            outlined
                            placeholder="Pilih bank"
                            class="modern-input"
                            :error-messages="errors"
                            required
                            @change="onBankChange"
                            style="border-radius: 10px;">
                          </v-autocomplete>
                        </ValidationProvider>
                      </v-col>

                      <v-col cols="12" md="6" class="pb-0">
                        <ValidationProvider
                          name="Nomor Rekening" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="fs-14 label-input font-weight-medium mb-2">
                            <v-icon size="16" color="#718EBF" class="mr-1">mdi-credit-card-outline</v-icon>
                            Nomor Rekening
                          </div>
                          <v-text-field
                            v-model="formPembayaran.rek_number"
                            filled
                            rounded
                            dense
                            solo
                            outlined
                            placeholder="Masukkan nomor rekening"
                            class="modern-input"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;">
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- Section 3: Bukti Pembayaran -->
                  <div class="form-section mb-3">
                    <div class="section-header mb-3">
                      <v-icon color="#2374e9" size="18" class="mr-2">mdi-image</v-icon>
                      <span class="fs-15 font-weight-bold black--text">Bukti Pembayaran</span>
                    </div>
                    
                    <div class="upload-section">
                      <uploadfolder
                        v-model="uploadPembayaran.bukti_url" 
                        style="height: 180px; width: 100%;">
                        <div slot="activator" class="cursor-pointer">
                          <v-card 
                            flat
                            height="180"
                            class="d-flex align-center justify-center upload-card"
                            style="border-radius: 6px; border: 2px dashed #D1D5DB; background: #F9FAFB;">
                            <div v-if="!formPembayaran.bukti_url || formPembayaran.bukti_url === '' || (typeof formPembayaran.bukti_url === 'string' && formPembayaran.bukti_url.length < 1)" class="text-center">
                              <v-icon v-if="!processPembayaran.bukti_url"
                                size="64" 
                                color="#718EBF"
                                class="mb-3">
                                mdi-cloud-upload-outline
                              </v-icon>
                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color"
                                size="48">
                              </v-progress-circular>
                              <div v-if="!processPembayaran.bukti_url" class="text-body-2 grey--text mt-2">
                                Klik untuk upload bukti pembayaran
                              </div>
                            </div>
                            <v-img v-else
                              contain
                              height="180"
                              :src="formPembayaran.bukti_url" 
                              :alt="formPembayaran.bukti_url"
                              class="text-center d-flex align-center"
                              style="border-radius: 6px;">
                              <div class="overlay-upload">
                                <v-icon size="48" color="white">mdi-camera</v-icon>
                                <div class="text-body-2 white--text mt-2">Klik untuk ganti gambar</div>
                              </div>
                            </v-img>
                          </v-card>
                        </div>
                      </uploadfolder>
                    </div>
                  </div>

                  <!-- Section 4: Informasi Penerima -->
                  <div class="form-section mb-2">
                    <div class="section-header mb-3">
                      <v-icon color="#2374e9" size="18" class="mr-2">mdi-account-check</v-icon>
                      <span class="fs-15 font-weight-bold black--text">Informasi Penerima</span>
                    </div>
                    
                    <v-row>
                      <v-col cols="12" md="12" class="pb-0">
                        <ValidationProvider
                          name="Nama Penerima" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="fs-14 label-input font-weight-medium mb-2">
                            <v-icon size="16" color="#718EBF" class="mr-1">mdi-account</v-icon>
                            Nama Penerima
                          </div>
                          <v-autocomplete
                            v-model="formPembayaran.receipt_user_name"
                            :items="usersReceipt"
                            :item-text="item => `${item.name} - ${item.category_user_title}`"
                            item-value="id"
                            return-object
                            filled
                            rounded
                            dense
                            solo
                            outlined
                            placeholder="Pilih nama penerima"
                            class="modern-input"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;">
                            <template v-slot:selection="{ item }">
                              <div v-if="item" style="color: #000">
                                {{ item.name }} - {{ item.category_user_title }}
                              </div>
                            </template>
                            <template v-slot:item="{ item }">
                              <v-list-item-content>
                                <v-list-item-title>{{ item.name }} - {{ item.category_user_title }}</v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </div>
                </v-form>
              </ValidationObserver>

              <!-- Error Message -->
              <div v-if="messagePembayaran.error.length > 0" class="px-0 pb-3 mt-3">
                <v-alert
                  type="error"
                  dense
                  outlined
                  style="border-radius: 10px;">
                  <div class="d-flex align-center">
                    <v-icon size="18" class="mr-2">mdi-alert-circle-outline</v-icon>
                    <span>{{ messagePembayaran.error }}</span>
                  </div>
                </v-alert>
              </div>
            </div>
          </v-card-text>

          <!-- Footer Actions -->
          <v-divider></v-divider>
          <v-card-actions class="pa-3">
            <v-spacer/>
            <v-btn
              @click="closeDialogTambahPembayaran()"
              outlined
              small
              height="38"
              style="border-radius: 8px; min-width: 110px;"
              class="mr-2 text-capitalize">
              <v-icon left size="16">mdi-close</v-icon>
              Batal
            </v-btn>
            <v-btn
              @click="savePembayaran()"
              :loading="processPembayaran.form"
              :disabled="processPembayaran.form"
              small
              height="38"
              elevation="0"
              color="#2374e9"
              style="border-radius: 8px; min-width: 160px;"
              class="white--text font-weight-bold text-capitalize">
              <v-icon left size="16">mdi-content-save</v-icon>
              Simpan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog Update Pembayaran -->
      <v-dialog v-model="dialog.updatePembayaran"
        @keydown.esc="dialog.updatePembayaran = false"
        max-width="500"
        persistent
        scrollable>
        <v-card 
          style="border-radius: 16px; overflow: hidden;"
          class="payment-form-dialog">
          <v-card-title 
            class="payment-form-header pa-4"
            style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
            <div class="d-flex align-center">
              <v-avatar size="36" color="white" class="mr-3">
                <v-icon color="#2374e9" size="18">mdi-cash-edit</v-icon>
              </v-avatar>
              <div>
                <div class="fs-16 white--text font-weight-bold" style="line-height: 1.5;">Update Pembayaran</div>
                <div class="fs-11 white--text" style="opacity: 0.9; line-height: 1.5;">
                  Perbarui informasi pembayaran yang sudah ada
                </div>
              </div>
            </div>
            <v-spacer/>
            <v-btn
              @click="closeDialogUpdatePembayaran()"
              icon
              small
              class="white--text">
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-0">
            <div class="px-4 pt-3 pb-3">
              <ValidationObserver ref="formUpdatePembayaran">
                <v-form>
                  <!-- Section 1: Informasi Pembayaran -->
                  <div class="form-section mb-4">
                    <div class="section-header mb-3">
                      <v-icon color="#2374e9" size="18" class="mr-2">mdi-information-outline</v-icon>
                      <span class="fs-15 font-weight-bold black--text">Informasi Pembayaran</span>
                    </div>
                    
                    <v-row>
                      <v-col cols="12" md="12" class="pb-0">
                        <ValidationProvider
                          name="Total Dibayar" 
                          :rules="`required|max_value:${sisa_tagihan_max}`" 
                          v-slot="{ errors }">
                          <div class="fs-14 label-input font-weight-medium mb-2">
                            <v-icon size="16" color="#718EBF" class="mr-1">mdi-cash</v-icon>
                            Total Dibayar
                          </div>
                          <v-currency-field
                            v-model="formUpdatePembayaran.total_paid"
                            filled
                            rounded
                            dense
                            solo
                            outlined
                            placeholder="Masukkan total pembayaran"
                            class="modern-input"
                            :error-messages="errors"
                            required
                            prefix="Rp"
                            style="border-radius: 10px;">
                          </v-currency-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- Section 2: Informasi Penerima -->
                  <div class="form-section mb-4">
                    <div class="section-header mb-3">
                      <v-icon color="#2374e9" size="18" class="mr-2">mdi-account</v-icon>
                      <span class="fs-15 font-weight-bold black--text">Informasi Penerima</span>
                    </div>
                    
                    <v-row>
                      <v-col cols="12" md="12" class="pb-0">
                        <ValidationProvider
                          name="Nama Penerima" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="fs-14 label-input font-weight-medium mb-2">
                            <v-icon size="16" color="#718EBF" class="mr-1">mdi-account-circle</v-icon>
                            Nama Penerima
                          </div>
                          <v-autocomplete
                            v-model="formUpdatePembayaran.receipt_user_name"
                            :items="usersReceipt"
                            :item-text="item => `${item.name} - ${item.category_user_title}`"
                            item-value="id"
                            return-object
                            filled
                            rounded
                            dense
                            solo
                            outlined
                            placeholder="Pilih nama penerima"
                            class="modern-input"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;">
                            <template v-slot:selection="{ item }">
                              <div v-if="item" class="d-flex align-center">
                                <v-icon size="18" color="#000" class="mr-2">mdi-account</v-icon>
                                <span style="color: #000">{{ item.name }} - {{ item.category_user_title }}</span>
                              </div>
                            </template>
                            <template v-slot:item="{ item }">
                              <v-list-item-content>
                                <v-list-item-title>
                                  <v-icon size="18" color="#000" class="mr-2">mdi-account</v-icon>
                                  {{ item.name }} - {{ item.category_user_title }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- Section 3: Tanggal Diterima -->
                  <div class="form-section mb-4">
                    <div class="section-header mb-3">
                      <v-icon color="#2374e9" size="18" class="mr-2">mdi-calendar</v-icon>
                      <span class="fs-15 font-weight-bold black--text">Tanggal Diterima</span>
                    </div>
                    
                    <v-row>
                      <v-col cols="12" md="12" class="pb-0">
                        <ValidationProvider
                          name="Tanggal Diterima" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="fs-14 label-input font-weight-medium mb-2">
                            <v-icon size="16" color="#718EBF" class="mr-1">mdi-calendar</v-icon>
                            Tanggal Diterima
                          </div>
                          <v-text-field
                            v-model="formUpdatePembayaran.diterima_date"
                            type="date"
                            filled
                            rounded
                            dense
                            solo
                            outlined
                            placeholder="Pilih tanggal diterima"
                            class="modern-input"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;">
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </div>
                </v-form>
              </ValidationObserver>

              <div v-if="messagePembayaran.error.length > 0" class="mt-4">
                <v-alert
                  type="error"
                  dense
                  outlined
                  class="mb-0">
                  <div class="d-flex align-center">
                    <v-icon size="18" class="mr-2">mdi-alert-circle-outline</v-icon>
                    <span>{{ messagePembayaran.error }}</span>
                  </div>
                </v-alert>
              </div>
            </div>
          </v-card-text>

          <v-card-actions class="pa-3">
            <v-spacer/>
            <v-btn
              @click="closeDialogUpdatePembayaran()"
              outlined
              small
              height="35"
              style="border-radius: 8px; min-width: 100px;"
              class="mr-2 text-capitalize">
              <v-icon left size="16">mdi-close</v-icon>
              Batal
            </v-btn>
            <v-btn
              @click="updatePembayaran()"
              :loading="processPembayaran.form"
              :disabled="processPembayaran.form"
              small
              height="35"
              elevation="0"
              color="#2374e9"
              style="border-radius: 8px; min-width: 140px;"
              class="white--text font-weight-bold text-capitalize">
              <v-icon left size="16">mdi-content-save</v-icon>
              Update Pembayaran
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          checkbox: false,
          tabs: 0,
          tab: [
            {
              title: 'Belum Lunas',
              id: 'belum lunas'
            },
            // {
            //   title: 'Pengajuan',
            //   id: 'pengajuan'
            // },
            {
              title: 'Lunas',
              id: 'lunas'
            },
          ],

          filterDataToko: '',
  
          dialog: {
            fullscreen: false,
            snackbar: false,
            freeze: false,
            hide: false,
  
            filter: false,
  
            form: false,
            delete: false,
            pilihInvoice: false,
            tambahPembayaran: false,
            updatePembayaran: false
          },
          
          search: '',
  
          filter: {
            year: new Date().getFullYear()
          },
        sortBy: 'id',
        sortDesc: '-',
  
          selected: {
            freeze: [],
            delete: [],
            row: []
          },
  
          sales: [],
  
          form: {
            id: '',
            sales_id: '',
            name_alias: '',
            name: '',
            mobilephone: '',
            address: '',
            pic_name: '',
            email: '',
            nik: '',
            npwp: '',
            plafon: '',
            faktur: '',
            term: '',
            ttd: ''
          },
  
          options: {},
          headers: [],
          list: [],
          pagination: {},
        paginationList: {},
        toko: [],
  
          lastIndex: 0,
          limit: 50,
  
          process: {
            load: false,
  
            delete: false
          },
          message: {
            success: '',
            error: ''
          },
          sisa_tagihan_max: 0,
          bank: [],
          usersReceipt: [],
          formPembayaran: {
            invoice_id: '',
            customer_id: '',
            store_id: '',
            total_paid: '',
            sisa_tagihan: '',
            receipt_user_name: '',
            payment_method: '',
            bank_name: '',
            rek_number: '',
            bukti_url: '',
            sudah_diterima: 'belum',
            diterima_date: '',
          },
          formUpdatePembayaran: {
            payment_id: '',
            receipt_user_name: '',
            diterima_date: '',
            total_paid: '',
          },
          uploadPembayaran: {
            bukti_url: null,
          },
          processPembayaran: {
            form: false,
            bukti_url: false,
          },
          messagePembayaran: {
            error: '',
          },
          selectedInvoice: null,
          listInvoice: [],
          searchInvoice: '',
          filterDataTokoInvoice: '',
          searchToko: '',
          selectedInvoiceItem: null,
          processInvoice: {
            load: false,
            loadMore: false
          },
          processToko: {
            load: false
          },
          searchTokoTimeout: null,
          invoicePagination: {
            page: 1,
            limit: 20,
            hasMore: false,
            total: 0
          }
        }
      },
      components: {
        pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
        uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue')
      },
      watch: {
        // 'options': {
        //   handler () {
        //     let pagination = { row: this.limit, page: 1 }
            
        //     this.fetch(pagination)
        //   },
        //   deep: true
        // }
        'uploadPembayaran.bukti_url': {
          handler: function () {
            if (this.uploadPembayaran.bukti_url) {
              this.messagePembayaran.error = ''
              this.processPembayaran.bukti_url = this.uploadPembayaran.bukti_url.process

              if (!this.processPembayaran.bukti_url) {
                // CALLBACK FROM UPLOAD IMAGE
                this.formPembayaran.bukti_url = this.uploadPembayaran.bukti_url.fileuri
              }
            }
          },
          deep: true
        },
        'formPembayaran.total_paid': function () {
          this.recalculateSisaTagihan()
        },
        'dialog.pilihInvoice': async function (newVal) {
          if (newVal) {
            // Reset data
            this.searchInvoice = ''
            this.filterDataTokoInvoice = ''
            this.searchToko = ''
            this.selectedInvoiceItem = null
            this.listInvoice = []
            this.invoicePagination.page = 1
            this.invoicePagination.hasMore = false
            
            // Fetch initial data toko (limit 50) dan invoice
            await this.fetchInvoiceList(true)
            await this.fetchEditToko('')
          }
        },
      },
      computed: {
        rps () {
          return this.$vuetify.breakpoint.name
        },
        user () {
          return this.$store.state.user
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        },
  
        configHeaders () {
          return this.headers.filter(header => !header.hide)  
        },
  
        years () {
          let max = new Date().getFullYear()+2, min = max - 2, years = []

          for (let i = max; i >= min; i--) {
            years.push({
              text: i,
              value: i
            })
          }

          return years
        },
        hasMoreInvoice () {
          return this.invoicePagination.hasMore
        }
      },
      mounted () {
      // this.fetchEditToko()
      this.fetch()
      this.fetchBank()
      this.fetchUsersReceipt()
    },
    methods: {
      async fetchEditToko(search = '') {
        // Check if data already exists in current list
        if (search && search.length > 0) {
          const searchLower = search.toLowerCase()
          const found = this.toko.some(item => 
            item.name && item.name.toLowerCase().includes(searchLower)
          )
          
          // If data already exists, no need to fetch
          if (found) {
            return
          }
        }
        
        this.processToko.load = true
        
        let params = {
          limit: 50,
          page: 1,
          status: 'approved',
          search: search || ''
        }
  
        await get('admin/toko/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            const newData = res.results.data || []
            
            if (search && search.length > 0) {
              // Merge with existing data, avoid duplicates
              const existingNames = this.toko.map(t => t.name)
              const uniqueNewData = newData.filter(item => 
                !existingNames.includes(item.name)
              )
              this.toko = [...this.toko, ...uniqueNewData]
            } else {
              // Initial load or clear search
              this.toko = newData
            }
          }
        })
        .catch(() => {
          // Handle error silently
        })
        .finally(() => {
          this.processToko.load = false
        })
      },
      onSearchToko(search) {
        // Debounce search
        if (this.searchTokoTimeout) {
          clearTimeout(this.searchTokoTimeout)
        }
        
        this.searchTokoTimeout = setTimeout(() => {
          if (search && search.length >= 2) {
            this.fetchEditToko(search)
          } else if (!search || search.length === 0) {
            // Reset to initial data when search is cleared
            this.fetchEditToko('')
          }
        }, 300)
      },
      toSort(name) {
        this.sortBy = name
        this.sortDesc = ''
        this.fetch()
      },
      toDesc() {
        this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
        this.fetch()
      },
        rowFormat (format, value) {
          let data = value
  
          if (format === 'number') {
            if (isNaN(value)) return 'Not a Number'
            let price = ''
  
            const reverseNumber = (value*1)
              .toString()
              .split('')
              .reverse()
              .join('')
            const arrReverseNumber = [...Array(reverseNumber.length).keys()]
  
            arrReverseNumber.map(index => {
              if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
            })
  
            return `Rp ${
              price.split('', price.length - 1)
              .reverse()
              .join('')
            }`
          } else if (format === 'array') {
            let arr = []
  
            for (let i = 0; i < value.length; i++) {
              arr.push(value[i].label)
            }
  
            data = arr.join(', ')
          } else if (format === 'date') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
          } else if (format === 'time') {
            data = value.length > 0 ? moment(value).format('HH:mm') : '-'
          } else if (format === 'datetime') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          } else if (format === 'object') {
            data = value.createdby.name
          } else if (format === 'regex') {
            // let regex = /(<([^>]+)>)/ig
  
            // data = value.replace(regex, '')
          } else if (format === 'underscore') {
            let regex = /_/g
  
            data = value.replace(regex, ' ')
          } else if (format === 'on_off') {
            data = value ? 'Online' : 'Offline'
          } else if (format === 'g_m') {
            data = value ? 'Mandiri' : 'Group'
          } else if (format === 'v_a') {
            data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
          } else if (format === 'y_n') {
            data = parseInt(value) ? 'Ya' : 'Tidak'
          } else if (format === 'percent') {
            data = Number(value) + ' %'
          } else if (format === 'action') {
            data = value
          } else if (format === 'bool') {
            data = value
          } else if (format === 'status') {
            data = value
          } else if (format === 'link') {
            data = value
          }  else {
            data = value ? 'Aktif' : 'Tidak Aktif'
          }
  
          return data
        },
  
        async fetch (pagination = { row: 50, page: 1 }) {
          this.process.load = true
  
          this.limit = pagination.row
          this.paginationList = pagination
  
          let params = {
            // is_delivery: '0',
            limit: pagination.row,
            page: pagination.page,
            sort: `${this.sortDesc}${this.sortBy}`,
            // sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0],
            // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
            search: this.search,
            sudah_diterima: 'belum',
            // unit_id: this.$store.state.user.unit_id === '0' || this.$store.state.user.unit_id === 0 ? '' : this.$store.state.user.unit_id
          }
  
          this.selected.row = []
  
          // admin/services/data
          
          await get(`admin/customer_payment/data`, { params })
          .then(response => {
            let res = response.data
            
            this.process.load = false
            
            this.list = []
            this.pagination = {}
            
            if (res.status === 200) {
              this.headers = [
                {
                  text: '',
                  width: '80px',
                  value: 'id',
                  freeze: true,
                  hide: false,
                  align: 'start',
                  format: 'action'
                },
                {
                  text: 'No',
                  width: '80',
                  value: 'index',
                  freeze: true,
                  hide: false
                },
                {
                  text: 'No. Invoice',
                  width: '200px',
                  value: 'number',
                  freeze: true,
                  hide: false
                },
                {
                  text: 'No. BPB',
                  width: '180px',
                  value: 'bpb_number',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Total Tagihan',
                  width: '200px',
                  value: 'sub_total',
                  freeze: false,
                  hide: false,
                  format: 'number'
                },
                // {
                //   text: 'Biaya Pengiriman',
                //   width: '200px',
                //   value: 'biaya_kirim',
                //   freeze: false,
                //   hide: false,
                //   format: 'number'
                // },
                {
                  text: 'Tanggal Jatuh Tempo',
                  width: '250px',
                  value: 'due_date',
                  freeze: false,
                  hide: false,
                  format: 'date'
                },
                // {
                //   text: 'Status',
                //   width: '150px',
                //   value: 'status',
                //   freeze: false,
                //   hide: false,
                //   format: 'status'
                // },
                // {
                //   text: 'No. BPB',
                //   width: '180px',
                //   value: 'bpb_number',
                //   freeze: false,
                //   hide: false
                // }
              
              ]
      
              this.list = res.results.data
              this.pagination = res.results.pagination
  
              // this.list.map(obj => {
              //   obj.is_active = obj.is_active === 'Aktif' ? true : false
              // })
  
              this.lastIndex = (pagination.page - 1) * pagination.row 
              this.lastIndex += 1
  
  
              this.addFreezes()
  
              this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
  
              if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
            }
          })
        },
  
  
        addFreezes () {
          this.removeFreezes()
  
          this.selected.freeze = []
  
          for (let i = 0; i < this.configHeaders.length; i++) {
            if (this.configHeaders[i].freeze) {
              // ADD TO SELECTOR
              this.selected.freeze.push({
                child: i + (this.checkbox ? 2 : 1),
                width: this.configHeaders[i].width.split('px')[0]
              })
  
              // LOOP STYLESHEET
              for (let f = 0; f < this.selected.freeze.length; f++) {
                let style = document.createElement('style'),
                    width = 0
  
                if (this.checkbox) {
                  width = f < 1 ? '65' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
                } else {
                  width = f < 1 ? '0' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
                }
  
                // ADD STYLESHET TO FREEZE
                style.innerHTML = `
                  .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 5;
                    background: #FFFFFF;
                  }
  
                  .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 1;
                  }
                `
  
                // ADD TO APPENDCHILD
                document.head.appendChild(style)
              }
            }
          }
        },
        removeFreezes () {
          // LOOP STYLESHEET
          for (let f = 0; f < this.selected.freeze.length; f++) {
            let style = document.createElement('style')
            
            // RESET STYLESHEET TO AUTO
            style.innerHTML = `
              .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
                background: #FFFFFF;
              }
  
              .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
              }
            `
  
            // ADD TO APPENDCHILD
            document.head.appendChild(style)
          }
        },
        addHides () {
          if (this.headers.length < 6) this.getTableToResize()
        },
        getTableToResize () {
          let tables = document.getElementsByTagName('table')
  
          for (let i = 0; i < tables.length; i++) {
            this.resizableGrid(tables[i])
          }
        },
        resizableGrid (table) {
          let row = table.getElementsByTagName('tr')[0],
              cols = row ? row.children : undefined
          
          if (!cols) return
          
          table.style.overflow = 'hidden'
          
          let tableHeight = table.offsetHeight
          
          for (let i = 0; i < cols.length; i++) {
            let div = createDiv(tableHeight)
            cols[i].appendChild(div)
            cols[i].style.position = 'relative'
  
            setListeners(div)
          }
  
          function setListeners (div) {
            let pageX, curCol, nxtCol, curColWidth, nxtColWidth
  
            div.addEventListener('mousedown', e => {
              curCol = e.target.parentElement
              nxtCol = curCol.nextElementSibling
              pageX = e.pageX
              
              let padding = paddingDiff(curCol)
              
              curColWidth = curCol.offsetWidth - padding
  
              if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
            })
  
            div.addEventListener ('mouseover', e => {
              e.target.style.borderRight = '2px solid #e0e0e0'
            })
  
            div.addEventListener ('mouseout', e => {
              e.target.style.borderRight = ''
            })
  
            document.addEventListener ('mousemove', e => {
              if (curCol) {
                let diffX = e.pageX - pageX
            
                if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'
  
                curCol.style.width = (curColWidth + diffX)+'px'
              }
            })
  
            document.addEventListener ('mouseup', () => { 
              curCol = undefined
              nxtCol = undefined
              pageX = undefined
              nxtColWidth = undefined
              curColWidth = undefined
            })
          }
  
          function createDiv (height) {
            let div = document.createElement('div')
  
            div.style.top = 0
            div.style.right = 0
            div.style.width = '1px'
            div.style.position = 'absolute'
            div.style.cursor = 'col-resize'
            div.style.userSelect = 'none'
            div.style.height = height + 'px'
            div.style.background = '#e0e0e0'
  
            return div
          }
  
          function paddingDiff (col) {
            if (getStyleVal(col,'box-sizing') == 'border-box') {
              return 0
            }
            
            let padLeft = getStyleVal(col,'padding-left')
            let padRight = getStyleVal(col,'padding-right')
  
            return (parseInt(padLeft) + parseInt(padRight))
          }
  
          function getStyleVal (elm,css) {
            return (window.getComputedStyle(elm, null).getPropertyValue(css))
          }
        },
  
        reset (index) {
          if (this.$refs.form) this.$refs.form.reset()
          
          this.form = {
            id: index !== undefined ? this.list[index].id : '',
            name: index !== undefined ? this.list[index].name : '',
            address: index !== undefined ? this.list[index].address : '',
            mobilephone: index !== undefined ? this.list[index].mobilephone : "",
            pic_name: index !== undefined ? this.list[index].pic_name : "",
            email: index !== undefined ? this.list[index].email : "",
            nik: index !== undefined ? this.list[index].nik : "",
            npwp: index !== undefined ? this.list[index].npwp : "",
            // is_active: index !== undefined ? this.list[index].is_active === 'Aktif'? 1 : 0 : 1
          }
  
          this.process.form = false
  
          this.message.error = ''
        },
  
        updateStatus (item) {
          this.selected.row = [item]
  
          this.dialog.form = true
        },
  
        async save () {
          this.message.error = ''
  
          const isValid = await this.$refs.form.validate()
  
          if (isValid) {
            this.process.form = true
  
            let url = this.form.id === '' ? 'admin/customer/add' : 'admin/customer/update'
  
            // SAVE TO REST API
            await post(url, {
              data: this.form
            })
            .then(response => {
              let res = response.data
              
              this.process.form = false
  
              if (res.status === 200) {
                this.dialog.form = false
  
                this.dialog.snackbar = true
                this.message.success = res.message
  
                this.dialog.fullscreen = false
  
                this.reset()
  
                this.fetch()
              } else {
                this.message.error = res.message
              }
            })
  
          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
        },
  
        toDelete (id) {
          this.selected.delete = [id]
  
          this.dialog.delete = true
        },
        async deletes () {
          this.message.error = ''
  
          this.process.delete = true
  
          await post(`admin/bpb/delete`, {
            data: {
              id: this.selected.delete[0]
            }
          }).then(response => {
            let res = response.data
  
            this.process.delete = false
  
            if (res.status === 200) {
  
              this.dialog.delete = false
  
              this.selected.row = []
              this.selected.delete = []
              
              this.dialog.snackbar = true
              this.message.success = res.message
  
              this.dialog.fullscreen = false
  
              this.fetch()
            } else {
              this.message.error = res.message
            }
          })
        },
        async fetchBank () {
          let params = {
            limit: 10000000000000000000
          }

          await get('admin/bank/data', { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.bank = res.results.data
            }
          })
        },
        async fetchUsersReceipt () {
          let params = {
            'category_user_id[in]': '8,11',
            limit: 1000000
          }

          await get('admin/user/data', { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.usersReceipt = res.results.data || []
            }
          })
        },
        openDialogTambahPembayaran () {
          // Get invoice detail first
          if (this.list.length === 0) {
            this.messagePembayaran.error = 'Tidak ada data invoice'
            return
          }
          
          // For now, we'll need to get invoice detail from API
          // But for simplicity, we can use the first item or let user select
          // For this implementation, we'll need invoice_id from selected item
          // Let's add a way to select invoice first
          this.messagePembayaran.error = 'Silakan pilih invoice dari list terlebih dahulu'
        },
        openDialogPilihInvoice () {
          this.dialog.pilihInvoice = true
          // Fetch akan otomatis dipanggil oleh watcher
        },
        closeDialogPilihInvoice () {
          this.dialog.pilihInvoice = false
          this.searchInvoice = ''
          this.filterDataTokoInvoice = ''
          this.searchToko = ''
          this.selectedInvoiceItem = null
          this.listInvoice = []
          this.invoicePagination.page = 1
          this.invoicePagination.hasMore = false
          
          // Clear timeout if exists
          if (this.searchTokoTimeout) {
            clearTimeout(this.searchTokoTimeout)
            this.searchTokoTimeout = null
          }
        },
        async fetchInvoiceList (reset = false) {
          if (reset) {
            this.invoicePagination.page = 1
            this.listInvoice = []
          }
          
          this.processInvoice.load = true
          
          let params = {
            status: 'belum lunas',
            limit: this.invoicePagination.limit,
            page: this.invoicePagination.page,
            search: this.searchInvoice,
            store_name: this.filterDataTokoInvoice
          }

          await get('admin/customer_invoice/data', { params })
          .then(response => {
            let res = response.data
            
            this.processInvoice.load = false
            
            if (res.status === 200) {
              const newData = res.results.data || []
              
              if (reset) {
                this.listInvoice = newData
              } else {
                this.listInvoice = [...this.listInvoice, ...newData]
              }
              
              // Check if there's more data
              const pagination = res.results.pagination || {}
              const totalData = pagination.total_data || 0
              const currentTotal = this.listInvoice.length
              
              this.invoicePagination.hasMore = currentTotal < totalData
              this.invoicePagination.total = totalData
            }
          })
          .catch(() => {
            this.processInvoice.load = false
            if (reset) {
              this.listInvoice = []
            }
          })
        },
        async loadMoreInvoice () {
          this.processInvoice.loadMore = true
          this.invoicePagination.page += 1
          
          await this.fetchInvoiceList(false)
          
          this.processInvoice.loadMore = false
        },
        async selectInvoice (item) {
          this.selectedInvoiceItem = item
          this.selectedInvoice = item
          
          // Ensure usersReceipt is loaded
          if (this.usersReceipt.length === 0) {
            await this.fetchUsersReceipt()
          }
          
          // Calculate sisa tagihan
          const netInvoiceTotal = this.getInvoiceNetTotal(item)
          const sisaTagihan = netInvoiceTotal - (item.total_paid*1)
          
          this.formPembayaran = {
            invoice_id: item.id,
            customer_id: item.customer_id || '',
            store_id: item.store_id || '',
            total_paid: '',
            sisa_tagihan: sisaTagihan > 0 ? sisaTagihan : 0,
            receipt_user_name: '',
            payment_method: '',
            bank_name: '',
            rek_number: '',
            bukti_url: '',
            sudah_diterima: 'belum',
            diterima_date: '',
          }
          this.messagePembayaran.error = ''

          console.log(this.formPembayaran)
          
          // Close dialog pilih invoice and open dialog tambah pembayaran
          this.dialog.pilihInvoice = false
          this.dialog.tambahPembayaran = true
        },
        openDialogTambahPembayaranWithInvoice (item) {
          this.selectedInvoice = item
          const netInvoiceTotal = this.getInvoiceNetTotal(item)
          this.formPembayaran = {
            invoice_id: item.id || item.invoice_id,
            customer_id: item.customer_id || '',
            store_id: item.store_id || '',
            total_paid: '',
            sisa_tagihan: item.sisa_tagihan || netInvoiceTotal,
            receipt_user_name: '',
            payment_method: '',
            bank_name: '',
            rek_number: '',
            bukti_url: '',
            sudah_diterima: 'belum',
            diterima_date: '',
          }
          this.messagePembayaran.error = ''
          this.dialog.tambahPembayaran = true
          this.recalculateSisaTagihan()
        },
        closeDialogTambahPembayaran () {
          this.dialog.tambahPembayaran = false
          this.messagePembayaran.error = ''
          this.selectedInvoice = null
          if (this.$refs.formTambahPembayaran) {
            this.$refs.formTambahPembayaran.reset()
          }
        },
        recalculateSisaTagihan () {
          if (!this.formPembayaran || !this.selectedInvoice) return
          // Hitung base dari total invoice dikurangi total yang sudah dibayar
          const base = (this.getInvoiceNetTotal(this.selectedInvoice) - (this.selectedInvoice?.total_paid*1))
          if (base < 0) {
            base = 0
          }
          
          // Konversi total_paid dari form (bisa string atau number)
          let totalPaidInput = this.formPembayaran.total_paid
          if (totalPaidInput === '' || totalPaidInput === null || totalPaidInput === undefined) {
            totalPaidInput = 0
          } else {
            totalPaidInput = parseFloat(totalPaidInput) || 0
          }
          
          // Jika input kurang dari 0, tidak perlu dihitung (tetap sama dengan base)
          if (totalPaidInput < 0) {
            this.formPembayaran.sisa_tagihan = base > 0 ? base : 0
            return
          }
          // Sisa tagihan langsung berkurang ketika total dibayar diisi
          let sisa = base - totalPaidInput
          if (sisa < 0) sisa = 0
          this.formPembayaran.sisa_tagihan = sisa
        },
        getInvoiceNetTotal (invoice) {
          const ordersDetail = Array.isArray(invoice && invoice.orders_detail) ? invoice.orders_detail : []
          const totalHarga = ordersDetail.reduce((sum, item) => {
            return sum + (Math.round((item.price_per_pcs * 1) * (item.total_in_dus * 1)) * (item.qty_dus_diterima * 1))
          }, 0)
          const totalDiskon = ordersDetail.reduce((sum, item) => sum + (item.discount * 1), 0)
          const totalStrata = ordersDetail.reduce((sum, item) => sum + ((item.strata_nominal * 1) * (item.qty_dus_diterima * 1)), 0)

          return totalHarga - totalDiskon - totalStrata
        },
        onBankChange () {
          // Auto-fill nomor rekening ketika bank dipilih
          if (this.formPembayaran.bank_name && this.bank && this.bank.length > 0) {
            const selectedBank = this.bank.find(b => b.name === this.formPembayaran.bank_name)
            if (selectedBank && selectedBank.rek_number) {
              this.formPembayaran.rek_number = selectedBank.rek_number
            }
          }
        },
        formatCurrency (value) {
          const number = isNaN(parseFloat(value)) ? 0 : parseFloat(value)
          return `Rp ${number.toLocaleString('id-ID')}`
        },
        async savePembayaran () {
          this.messagePembayaran.error = ''
          const isValid = await this.$refs.formTambahPembayaran.validate()
          
          if (!isValid) {
            return
          }

          if (!this.formPembayaran.bukti_url || this.formPembayaran.bukti_url === '') {
            this.messagePembayaran.error = 'Bukti Pembayaran harus diisi'
            return
          }

          this.processPembayaran.form = true

          let formData = new FormData()
          formData.append('invoice_id', this.formPembayaran.invoice_id)
          formData.append('customer_id', this.formPembayaran.customer_id)
          formData.append('store_id', this.formPembayaran.store_id)
          formData.append('total_paid', this.formPembayaran.total_paid)
          formData.append('sisa_tagihan', this.formPembayaran.sisa_tagihan)
          const receiptUserObj = this.formPembayaran.receipt_user_name
          formData.append('receipt_user_category', receiptUserObj && receiptUserObj.category_user_title ? receiptUserObj.category_user_title : '')
          formData.append('receipt_user_name', receiptUserObj && receiptUserObj.name ? receiptUserObj.name : '')
          formData.append('payment_method', this.formPembayaran.payment_method)
          if (this.formPembayaran.payment_method === 'transfer') {
            formData.append('bank_name', this.formPembayaran.bank_name)
            formData.append('rek_number', this.formPembayaran.rek_number)
          }
          formData.append('bukti_url', this.formPembayaran.bukti_url)
          formData.append('sudah_diterima', this.formPembayaran.sudah_diterima)
          formData.append('diterima_date', this.formPembayaran.diterima_date)

          const { VUE_APP_API_URL, VUE_APP_XAUTH } = process.env
          const bearerToken = TokenService.getToken()

          await axios.post(`${VUE_APP_API_URL}admin/customer_payment/add`, formData, {
            headers: {
              'Authorization': `${VUE_APP_XAUTH} ${bearerToken}`,
              'token': bearerToken,
              'Accept': 'application/json'
            }
          }).then(response => {
            let res = response.data

            this.processPembayaran.form = false

            if (res.status === 200) {
              this.closeDialogTambahPembayaran()
              this.dialog.snackbar = true
              this.message.success = res.message
              this.fetch()
            } else {
              this.messagePembayaran.error = res.message
            }
          })
          .catch(error => {
            this.processPembayaran.form = false
            if (error.response && error.response.data && error.response.data.message) {
              this.messagePembayaran.error = error.response.data.message
            } else {
              this.messagePembayaran.error = 'Terjadi kesalahan saat menyimpan data'
            }
          })
        },
        openDialogUpdatePembayaran (item) {
          this.sisa_tagihan_max = item.sisa_tagihan*1
          if (this.sisa_tagihan_max < 0) {
            this.sisa_tagihan_max = 0
          }
          let userObj = this.usersReceipt.find(u => u.name === item.receipt_user_name)
          
          this.formUpdatePembayaran = {
            payment_id: item.id,
            receipt_user_name: userObj || item.receipt_user_name || '',
            diterima_date: item.diterima_date || '',
            total_paid: item.total_paid === '0.00' ? 0 : item.total_paid*1 || '',
          }

          // console.log(this.formUpdatePembayaran)
          this.messagePembayaran.error = ''
          this.dialog.updatePembayaran = true
        },
        closeDialogUpdatePembayaran () {
          this.dialog.updatePembayaran = false
          this.messagePembayaran.error = ''
          if (this.$refs.formUpdatePembayaran) {
            this.$refs.formUpdatePembayaran.reset()
          }
        },
        async updatePembayaran () {
          this.messagePembayaran.error = ''
          const isValid = await this.$refs.formUpdatePembayaran.validate()
          
          if (!isValid) {
            return
          }

          this.processPembayaran.form = true

          let formData = new FormData()
          formData.append('payment_id', this.formUpdatePembayaran.payment_id)
          const receiptUserUpdateObj = this.formUpdatePembayaran.receipt_user_name
          formData.append('receipt_user_category', receiptUserUpdateObj && receiptUserUpdateObj.category_user_title ? receiptUserUpdateObj.category_user_title : '')
          formData.append('receipt_user_name', receiptUserUpdateObj && receiptUserUpdateObj.name ? receiptUserUpdateObj.name : '')
          formData.append('diterima_date', this.formUpdatePembayaran.diterima_date)
          formData.append('total_paid', this.formUpdatePembayaran.total_paid)

          const { VUE_APP_API_URL, VUE_APP_XAUTH } = process.env
          const bearerToken = TokenService.getToken()

          await axios.post(`${VUE_APP_API_URL}admin/customer_payment/update`, formData, {
            headers: {
              'Authorization': `${VUE_APP_XAUTH} ${bearerToken}`,
              'token': bearerToken,
              'Accept': 'application/json'
            }
          }).then(response => {
            let res = response.data

            this.processPembayaran.form = false

            if (res.status === 200) {
              this.closeDialogUpdatePembayaran()
              this.dialog.snackbar = true
              this.message.success = res.message
              this.fetch()
            } else {
              this.messagePembayaran.error = res.message
            }
          })
          .catch(error => {
            this.processPembayaran.form = false
            if (error.response && error.response.data && error.response.data.message) {
              this.messagePembayaran.error = error.response.data.message
            } else {
              this.messagePembayaran.error = 'Terjadi kesalahan saat mengupdate data'
            }
          })
        },
        getPaymentMethodColor (method) {
          const colors = {
            'transfer': '#3b82f6',
            'tunai': '#10b981',
            'giro': '#8b5cf6'
          }
          return colors[method?.toLowerCase()] || '#6b7280'
        }
  
      }
    }
  </script>
  
  <style>
    /* ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      background-color: #F5F5F5;
    }
    ::-webkit-scrollbar-track{
      background-color: #F5F5F5;
      border-radius: 10px;
    } */
    ::-webkit-scrollbar-thumb{
      border-radius: 10px;
      background-color: #718EBF;
    }
    table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
    border-collapse: collapse;
  }

  .view {
    margin: auto;
    /* width: 100%; */
  }

  .wrapper-pengajuan-invoice { 
    overflow-y: auto; 
    height: calc(100vh - 315px);
  } 

  .wrapper th { 
    position: sticky; 
    top: 0; 
    background-color: white !important;
  } 
  .sticky-col-pengajuan-invoice {
    position: -webkit-sticky;
    position: sticky;
    background-color: white !important;
  }

  .one-col-pengajuan-invoice {
    width: 120px;
    min-width: 120px;
    max-width: 120px;
    left: 0px;
  }

  .second-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 150px;
  }

  .three-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 300px;
  }

  .four-col {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    left: 450px;
  }

  tr:hover {background-color: #1976d236;}
  tr.selected {background-color: #1976d236;}

  .payment-form-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }

  .form-section {
    margin-bottom: 1.5rem;
  }

  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 0.75rem;
  }

  .modern-input {
    border-radius: 10px;
  }

  .upload-card {
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .upload-card:hover {
    border-color: #718EBF !important;
    background: #F0F4FF !important;
  }

  .overlay-upload {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: 6px;
  }

  .upload-card:hover .overlay-upload {
    opacity: 1;
  }

  .selected-invoice {
    background-color: #E3F2FD !important;
    border-color: #1976D2 !important;
  }
</style>